import { useQuery } from "@tanstack/react-query";

import { getPartnerSummaryService } from "./service";

export const partnerSummaryQueryKey = ["v1/partner_summary_admin"];

export function usePartnerSummaryQuery() {
  return useQuery({
    queryKey: partnerSummaryQueryKey,
    queryFn: getPartnerSummaryService,
  });
}
